import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeKey } from '../../hooks/useConvertForTranslationKey';
export const ClaimTemplateList = _ref => {
  let {
    claimTemplateTasks
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("table", {
    className: "table table-bordered"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, t('category_order')), /*#__PURE__*/React.createElement("th", null, t('category_title')), /*#__PURE__*/React.createElement("th", null, t('task_order')), /*#__PURE__*/React.createElement("th", null, t('task_title')), /*#__PURE__*/React.createElement("th", null, t('template_name')))), /*#__PURE__*/React.createElement("tbody", null, claimTemplateTasks && claimTemplateTasks.map(task => {
    return /*#__PURE__*/React.createElement("tr", {
      key: task.id
    }, /*#__PURE__*/React.createElement("td", null, task.claim_template_category.order), /*#__PURE__*/React.createElement("td", null, t(makeKey(task.claim_template_category.title))), /*#__PURE__*/React.createElement("td", null, task.order), /*#__PURE__*/React.createElement("td", null, t(makeKey(task.title))), /*#__PURE__*/React.createElement("td", null, task.claim_template_category.claim_template_name));
  })));
};